import { render, staticRenderFns } from "./pharmacy-details.vue?vue&type=template&id=55effc29&"
import script from "./pharmacy-details.vue?vue&type=script&lang=js&"
export * from "./pharmacy-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports